import React, { useRef } from 'react';
import VideoSliderItem from './video-slider-item';

import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { IconButton } from './icon-button';
import { IPostDirect } from '../models/post';
import { H3 } from './text';

interface IProps {
	data: IPostDirect[];
	title: string;
	baseSlug: string;
}

export function VideoCategorySlider({ data, title, baseSlug }: IProps) {
	const swiperRef = useRef<SwiperRef | null>(null);

	return (
		<div>
			<div className="flex justify-between items-center mb-4">
				<H3 className="mb-4 text-white uppercase">{title}</H3>
				<div className="flex">
					<IconButton
						className="ml-4"
						icon="arrow-left"
						onClick={() => swiperRef.current?.swiper.slidePrev()}
					/>
					<IconButton
						className="ml-4"
						icon="arrow-right"
						onClick={() => swiperRef.current?.swiper.slideNext()}
					/>
				</div>
			</div>
			<Swiper
				loop
				ref={swiperRef}
				slidesPerView={4}
				spaceBetween={15}
				modules={[Autoplay]}
				breakpoints={{
					0: {
						slidesPerView: 2,
					},
					768: {
						slidesPerView: 3,
					},
					1280: {
						slidesPerView: 4,
					},
				}}
				className="video-swiper"
			>
				{data.map((video) => (
					<SwiperSlide key={video.slug}>
						<VideoSliderItem
							title={video.title}
							coverImage={video.featuredImage}
							baseSlug={baseSlug}
							slug={video.slug}
							light
						/>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
}
